import { AutoPopupKey } from './auto-popup-key';

/** Default priority: first match wins; lower in list shows after higher-priority popups dismiss */
export const DEFAULT_AUTO_POPUP_ORDER: AutoPopupKey[] = [
	AutoPopupKey.ForgetPassword,
	AutoPopupKey.SignUp,
	AutoPopupKey.MemberLogin,
	AutoPopupKey.PopupBannerList,
];